module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG7bad2c9d5db4195c4732a6ade905cac1.7bad2c9d.png";